interface AppConfig {
  SANDBOX_FRONTEND_URL: string;
}

let cached: AppConfig | null = null;

export async function getConfig(): Promise<AppConfig> {
  if (cached) return cached;
  const res = await fetch("/api/config");
  if (!res.ok) throw new Error("Failed to load app config");
  cached = await res.json();
  return cached!;
}
